import { render, staticRenderFns } from "./ResourceDynamic.vue?vue&type=template&id=a32e6176&scoped=true"
import script from "./ResourceDynamic.vue?vue&type=script&lang=js"
export * from "./ResourceDynamic.vue?vue&type=script&lang=js"
import style0 from "./ResourceDynamic.vue?vue&type=style&index=0&id=a32e6176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32e6176",
  null
  
)

export default component.exports